<template>
  <el-popover placement="bottom" :width="width" trigger="click" :append-to-body="false" @show="show">
    <el-input ref="input" slot="reference" :value="keyword" clearable :size="size" :disabled="disabled" :placeholder="placeholder" :style="style" @focus="focus" @clear="clear">
      <el-button slot="append" icon="el-icon-search" @click="search" />
    </el-input>

    <template>
      <el-input v-model="textarea" ref="textarea" type="textarea" resize="none" :disabled="disabled" :rows="6" :placeholder="placeholder" />
    </template>
  </el-popover>
</template>

<script>
export default {
  props: {
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    size: {
      type: String,
      required: false,
      default: 'medium'
    },
    width: {
      type: Number,
      required: false,
      default: 298
    },
    placeholder: {
      type: String,
      required: false,
      default: '请输入邮箱/手机号'
    }
  },
  data() {
    return {
      keyword: undefined,
      textarea: undefined
    }
  },
  computed: {
    style() {
      return {
        width: `${this.width}px`
      }
    }
  },
  watch: {
    textarea(value) {
      let result = value.split(/[\r\n]+/).filter((item) => item !== '')
      this.keyword = result.join(',')
    }
  },
  methods: {
    show() {
      this.$nextTick(() => {
        this.$refs.textarea.focus()
      })
    },

    focus() {
      this.$refs.input.blur()
    },

    clear() {
      this.keyword = undefined
      this.textarea = undefined
      this.$emit('clear')
    },

    search() {
      this.$emit('search', this.keyword)
    }
  }
}
</script>
